import { useQuery } from '@based/sdk'
import { useAppCtx } from '../providers/useAppCtx'
import { ContentType } from '@/shared/constants'
import useLocalStorage from '@based/use-local-storage'

export const useContentQuery = (content: typeof ContentType.infer) => {
  const ctx = useAppCtx()
  const [storageActiveLanguage] = useLocalStorage('language')

  if (!ctx.content) {
    return {
      loading: false,
      data: null,
      error: true,
      checksum: 0,
    }
  }

  // @ts-ignore
  const edition = window.DATA?.edition
  const isAbleToCall = edition !== undefined && content !== undefined

  const res = useQuery(isAbleToCall ? ctx.content : '', {
    id: edition,
    content,
    lang: storageActiveLanguage ?? 'en',
  })

  return res
}
